export default __webpack_public_path__ + "static/media/copy.2af3a206.gif";